module.exports = __webpack_public_path__ + "img/status_1.844df029.png";